module.exports = __webpack_public_path__ + "static/media/admin.bb18f2e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/img/admin.svg
// module id = 155
// module chunks = 0